import { tv, type VariantProps } from "tailwind-variants";

export const documentationHeaderVariant = tv({
  slots: {
    base: ["w-full", "py-4"],
    container: ["container-fluid"],
    wrapper: ["flex", "flex-col", "gap-8", "pb-8", "section-border"],
    mediaWrapper: [
      "w-full",
      "h-full",
      "relative",
      "rounded-2xl",
      "overflow-hidden",
      "mobile:aspect-[1/1]",
    ],
    media: ["w-full", "h-full", "object-cover"],
    content: ["flex", "flex-col", "gap-5", "max-w-166"],
    title: ["text-neutral-default"],
    description: ["text-neutral-soft"],
  },
  variants: {},
  defaultVariants: {},
});

export type DocumentationHeaderVariantProps = VariantProps<
  typeof documentationHeaderVariant
>;
export type DocumentationHeaderReturnVariantProps = ReturnType<
  typeof documentationHeaderVariant
>;
